export default __webpack_public_path__ + "static/media/Roboto-Light.03e629f6.ttf";